module.exports = __webpack_public_path__ + "static/Burst_8s-22fab6ac1d14908ad9cebe89b711f3a9.jpg";